module.exports = __webpack_public_path__ + "img/22.4cd9ff6b.png";